import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { fetch, save } from '../../../actions/settings';
import SetiingsEdit from './SettingsEdit';

export default connect(
  (state) => ({
    title: 'Create Message',
    loading: state.settings.loading,
    model: state.settings.model
  }),
  dispatch => ({
    fetch: () => dispatch(fetch()),
    save: (item) => dispatch(save(item)),
    cancel: () => dispatch(push('/'))
  })
)(SetiingsEdit)



// WEBPACK FOOTER //
// ./src/components/Settings/SettingsEdit/index.js